import ManagementPageHTML, {
  IdentityCell,
  StatusBadge,
} from "../../components/ManagementPage/ManagementPageHTML";
import { BannerService } from "../../services/BannerService";
import type { Banner } from "../../models/Banner";
import { Status } from "../../models/Status";
import { resolveImageUrl } from "../../utils/ImageUrl";
export default function BannerHTML() {
  return (
    <ManagementPageHTML<Banner>
      Title="Banners"
      Eyebrow="Storefront content"
      Description="Upload banner images, set display order and destination links, and activate or deactivate banners."
      AddLabel="Upload banner"
      SearchPlaceholder="Search banners"
      Service={BannerService()}
      Rows={[]}
      Summaries={[]}
      CanDelete={false}
      DefaultValues={{
        Code: "",
        Status: Status.Active,
        Position: 1,
        LinkToNavigateTo: "",
      }}
      Columns={[
        {
          Key: "Image",
          Header: "Preview",
          Render: (row) =>
            row.ImageUrl ? (
              <img
                className="management-image-preview"
                src={resolveImageUrl(row.ImageUrl)}
                alt={row.Name}
              />
            ) : (
              "No image"
            ),
        },
        {
          Key: "Name",
          Header: "Banner",
          Render: (row) => (
            <IdentityCell
              Icon="fa-image"
              Title={row.Name}
              Subtitle={row.Code}
            />
          ),
        },
        {
          Key: "Description",
          Header: "Description",
          Render: (row) => row.Description,
        },

        { Key: "Position", Header: "Position", Render: (row) => row.Position },
        {
          Key: "Link",
          Header: "Destination",
          Render: (row) => row.LinkToNavigateTo || "No link",
        },
        {
          Key: "Status",
          Header: "Status",
          Render: (row) => <StatusBadge Status={row.Status} />,
        },
      ]}
      DialogFields={[
        { Key: "Name", Label: "Banner name", Required: true, FullWidth: true },
        {
          Key: "Description",
          Label: "Banner description",
          Type: "textarea",
          FullWidth: true,
        },
        {
          Key: "Position",
          Label: "Display position",
          Type: "integer",
          Required: true,
          HelpText: "Lower positions appear first.",
        },
        {
          Key: "Status",
          Label: "Status",
          Type: "select",
          Options: [Status.Active, Status.InActive],
          Required: true,
        },
        {
          Key: "LinkToNavigateTo",
          Label: "Navigation link",
          Placeholder: "/products or https://example.com",
          FullWidth: true,
        },
        { Key: "Image", Label: "Banner image", Type: "image", FullWidth: true },
      ]}
      ValidateForm={(v) => {
        const errors: Record<string, string> = {};
        if (!Number.isInteger(Number(v.Position)) || Number(v.Position) < 1)
          errors.Position = "Use a whole position of 1 or greater.";
        if (!v.Image && !v.ImageUrl) errors.Image = "Upload a banner image.";
        const link = String(v.LinkToNavigateTo || "");
        if (link && !/^\/(?!\/)|^https?:\/\//i.test(link))
          errors.LinkToNavigateTo =
            "Use an application path or an HTTP/HTTPS address.";
        return errors;
      }}
      Statuses={[Status.Active, Status.InActive]}
      GetStatus={(row) => row.Status}
      GetRowKey={(row) => row.Code}
      GetSearchText={(row) => `${row.Name} ${row.Code} ${row.LinkToNavigateTo}`}
    />
  );
}
